import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemImage',
  props: {
    image: {
        required: false,
        default: null,
        validator: prop => typeof prop === "string" || prop === null,
        type: String
    },
    url: {
        required: false,
        default: null,
        validator: prop => typeof prop === "string" || prop === null,
        type: String
    },
    productName: {
        required: false,
        default: null,
        type: String
    },
    isServiceProduct: {
        type: Boolean
    }
},
  setup(__props) {

const props = __props



const hasImage = computed<boolean>(() => !!props.image);
const hasUrl = computed<boolean>(() => props.url !== null);

return { __sfc: true,props, hasImage, hasUrl }
}

})